import ActionTypes from "../../../enums/ActionTypes"

export default function (state = {}, action) {
  switch (action.type) {
    case ActionTypes.UI_AVAILABLE_HOURS_PER_DAY_SET_VALUES: {
      const { payload } = action

      return {
        ...state,
        values: payload,
      }
    }
    default:
      return state
  }
}
